import React, { useState, useEffect } from "react";
import classes from "../../../controls.module.scss";
import eventClasses from "./eventdetails.module.scss"
import { Box, Grid, Button, IconButton, Typography } from '@mui/material';
import { Icon, Dialog, useToggle, Radio,DatePicker } from '@genesis/ui-kit';
import { FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField, RadioGroup } from '@mui/material';
import { Checkbox } from '@genesis/ui-kit';
import { useSelector } from "react-redux";
import Cookie from "js-cookie";
import axios from "axios";
import axiosInstance from "../../../../../Shared/Utill/AxiosConfig";
import { constants } from "../../../../../Shared/Url/Constants";
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import bloomiesReceiptIcon from "../../../../../Resources/bloomiesrcpt.png"
import add from "../../../../../Resources/add.png";
import duplicate from "../../../../../Resources/duplicate.png";
import deleteimg from "../../../../../Resources/delete.png";
import add_disable from "../../../../../Resources/add_disable.png";
import duplicate_disable from "../../../../../Resources/duplicate_disable.png";
import delete_disable from "../../../../../Resources/delete_disable.png";
import warning_delete from "../../../../../Resources/warning_delete.png";

import EventDetailsComponent from "./EventDetailsComponent";
import EventHours from "./EventHours";
import EventShifts from "./EventShifts";
import ScheduledAreas from "./ScheduledAreas";
import WorkSchedule from "./WorkSchedule";
import Edit from "./Edit"
import { useLocation, useNavigate } from "react-router-dom";
//import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { CalIcon } from "../../../../../Resources/availabilityicon/IconUtils";
import moment from 'moment';
import SnackBar from "../../../../../Shared/Snackbar/Snackbar";
import NotificationView from "../../../../../Shared/Notification/NotificationView";
import { toUpperCaseString } from "../../../../../Shared/Utill/Utills";
import { isString } from '../../../../../Shared/Utill/Utills';
/*
* dneed to have use effect to handle rerendering of page on delete/add of event hours.
* need to have method that will run firstrow method and a loop of add rows method depending on 
* # of elements to map through  based on API repsonse/props for event hours.
*/
const EventDetailsPage = () => {
    const personDetails = useSelector((state) => state.person.personData);
    const personStaticDetails = useSelector((state) => state.personStatic.personStaticData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const colleagueTKN = Cookie.get('X_TKN');
    const dialog = useToggle();
    const [isAlertOpen, setAlertOpen] = React.useState({});
    const [rowCount, updateRowCount] = React.useState(1)
    const [startTime, setStartTime] = React.useState({})
    const [endTime, setEndTime] = React.useState("")
    const [eventHoursList, setEventHoursList] = React.useState([])
    const [readOnlyView, setReadyOnly] = React.useState(true);
    const [haveRemoved, setHaveRemoved] = React.useState(true);
    const [haveAdded, setHaveAdded] = React.useState(true);
    const location = useLocation();
    const [scheduleArea, setscheduleArea] = React.useState(" ")
    const [scheduleAreaRadio, setscheduleAreaRadio] = React.useState("")
    const [workSchedule, setWorkSchedule] = React.useState(" ")
    const [workScheduleRadio, setWorkScheduleRadio] = React.useState("")
    const [allowSplitShift, setAllowSplitShift] = React.useState(false)
    const [forceMinSelectionHours, setForceMinSelectionHours] = React.useState(false)
    const [activateEvent, setActivateEvent] = React.useState(false)
    const [allowUnavailable, setAllowUnavailable] = React.useState(false)
    const token = Cookie.get('X_TKN');
    const [allowPartialShiftSelection, setAllowPartialShiftSelection] = React.useState("");
    const { message, severity, open } = isAlertOpen || {};

    const [startHours, setStartHours] = React.useState({})
    const [endHours, setEndHours] = React.useState({})

    // event details states
    const [eventStartDate, setEventStartDate] = React.useState("");
    const [eventEndDate, setEventEndDate] = React.useState("");
    const [displayStartDate, setDisplayStartDate] = React.useState("");
    const [displayEndDate, setDisplayEndDate] = React.useState("");
    const [division, setDivision] = React.useState("");
    const [eventLocation, setEventLocation] = React.useState("");
    const [eventId, setEventId] = React.useState("");
    const [eventName, setEventName] = React.useState("");
    const [eventBaseData, setEventBaseData] = React.useState(location.state.data)
    const [eventDetailApiData, setEventDetailApiData] = React.useState(null);
    const [eventLocationId, setEventLocationId] = React.useState("");

    //shifts state
    const [shiftsDropDownIntervals, setShiftsDropDownIntervals] = React.useState("");
    const [shiftsMinimumSelectionHours, setshiftsMinimumSelectionHours] = React.useState("");

    // other opertaion enable/disable
    const [ongoingActionCompleted, setOngoingActionCompleted] = React.useState(true);

    // get flag from previous page.
    const [flag, setFlag] = React.useState(location.state.flag);
    const [flag2,setFlag2] = React.useState("");

    //cancel editing
    const [cancelFlag, setCancelFlag] = React.useState(false);

    const history = useNavigate();


    console.log("event base data", eventBaseData)
    /*
    *Setup method for mapping through json event hours depending on eventhours add/delete to map
    *Setup boolean state for showing add/delete based on map element
    */

    useEffect(() => {
        if(location.state.data !==null && location.state.flag2 === "FE") {
            console.log("Checking if add can send " + JSON.stringify(location.state.data))
        }
        
        if (eventBaseData.locId !== null && (flag === 'E' || flag === 'C')) {
            if (flag === 'E') {
                setFlag2("FE")
            }
           
            if(flag ==='C') {
                setReadyOnly(false);
                setOngoingActionCompleted(false);
                setAlertOpen({
                    open: true,
                    severity: "success",
                    message: "Please edit and save to duplicate into a new event location",
                })
            }
            getEventDetailsApi();
        } else {
            // set flag to A
            setFlag("A");

            // set the state when Flag is A
            setDivision(eventBaseData.divNbr + "-" + eventBaseData.divName);
            setEventLocation(eventBaseData.locNbr === null ? 0 : eventBaseData.locNbr);
            setEventId(eventBaseData.eventId);
            setEventName(eventBaseData.eventName);

            // set editable to false
            setReadyOnly(false);
            setOngoingActionCompleted(false);

        }

    }, []);



    const makeEditable = () => {
        setOngoingActionCompleted(false);
        console.log(readOnlyView + " ready only ")
        if (readOnlyView == true) {
            setReadyOnly(false)
        }
        setCancelFlag(!cancelFlag)
    }
    const makeReadOnly = () => {
        //on click of save
        setOngoingActionCompleted(true);
        if (readOnlyView == false) {
            setReadyOnly(true)
        }
    }



    const addEvent = () => {
        //alert(JSON.stringify(location.state.data))
        setFlag("A");
        // set editable to false
        setReadyOnly(false);
        setOngoingActionCompleted(false);
        setEventDetailApiData(null);

        // reset values to default   

        // location and event dates reset
        setEventStartDate(null);
        setEventEndDate(null);
        setDisplayStartDate(null);
        setDisplayEndDate(null);
        setEventLocation("");

        // activated event checkbox reset
        setActivateEvent(false);
        setAllowUnavailable(false);

        // shifts reset
        setShiftsDropDownIntervals("");
        setshiftsMinimumSelectionHours("");
        setAllowSplitShift(false);
        setForceMinSelectionHours(false);

        // department reset

        setscheduleArea("")
        setscheduleAreaRadio("")
        setWorkSchedule("")
        setWorkScheduleRadio("")

    }

    const duplicateEvent = () => {
        setFlag("C");
        setReadyOnly(false);
        setOngoingActionCompleted(false);
        setEventLocation("");
        setAlertOpen({
            open: true,
            severity: "success",
            message: "Please edit and save to duplicate into a new event location",
        })
    }


    const Edit = () => {
        return (
            <div>
                <div className={eventClasses.eventpagemargin}>
                    <Grid container spacing={3} >
                        <Grid item xs={2}>
                            <div className={eventClasses.scheduledAreas}>  </div>
                        </Grid>
                        <Grid item xs={2}>

                        </Grid>
                        <Grid item xs={2} >

                        </Grid>
                        <Grid item xs={3} >
                            {!readOnlyView && (flag === "E" || flag === "C") && (flag2 === "FE") && <Button sx={{ minWidth: "100%" }} color="secondary" onClick={cancelEditing} >Cancel</Button>}
                            {!readOnlyView && (flag === "C" && flag2 !=="FE") && <Button sx={{ minWidth: "100%" }} color="secondary" onClick={() => history("/controls/specialeventscontrols/searchevent")} >Cancel</Button>}
                            {!readOnlyView && (flag === "A" && flag2 !== "FE") && <Button sx={{ minWidth: "100%" }} color="secondary" onClick={() => history("/controls/specialeventscontrols/searchevent")} >Cancel</Button>}
                            {!readOnlyView && (flag === "A" && flag2 === "FE") && <Button sx={{ minWidth: "100%" }} color="secondary" onClick={cancelEditing} >Cancel</Button>}
                        </Grid>
                        <Grid item xs={3} >
                            {readOnlyView &&
                                <Button sx={{ minWidth: "100%" }} onClick={makeEditable} >Edit</Button>
                            } {!readOnlyView && <Button sx={{ minWidth: "100%" }} onClick={saveData} >Save</Button>}

                        </Grid>
                        <Grid item xs={2} >
                        </Grid>
                    </Grid>

                </div>
            </div>
        )
    }

    const changeWorkScheduleRadio = (e) => {
        setWorkScheduleRadio(e.target.value)
    }

    const changeWorkSchedule = (e) => {
        setWorkSchedule(e.target.value)
    }

    const changeScheduleAreaRadio = (e) => {
        setscheduleAreaRadio(e.target.value)
    }

    const changeScheduleArea = (e) => {
        setscheduleArea(e.target.value)
    }

    const changeAllowSplitShift = (e) => {
        setAllowSplitShift(e.target.checked)
    }

    const changeForceMinSelectionHours = (e) => {
        setForceMinSelectionHours(e.target.checked)
    }

    const changeActivateEvent = (e) => {
        setActivateEvent(e.target.checked)
    }

    const changeAllowUnavailable = (e) => {
        setAllowUnavailable(e.target.checked)
    }

    const changeDropDownIntervals = (e) => {
        setShiftsDropDownIntervals(e.target.value)
    }

    const changeShiftsMinimumSelectionHours = (e) => {
        setshiftsMinimumSelectionHours(e.target.value)
    }

    const cancelEditing = () => {
        if (flag2 === "FE"){
            //alert("Checking if i can make the edit screen field load call " + JSON.stringify(location.state.data))  
            setFlag("E")
        }
        setOngoingActionCompleted(true);
        // call api to reset values
        makeReadOnly();
        getEventDetailsApi(null,null, "E");
        setCancelFlag(!cancelFlag)
        //{ state: {data: location.state.data, flag:"E",flag2:"FE"
    }   


    const changeLocation = (e) => {
        setEventLocation(e.target.value)
    }

    const setUpEventDetailsStatesValues = (resp, flag1 = null) => {
        // setup initial values from getData API for event details sections
        setEventStartDate(resp.eventDetailsEventStartDate);
        setEventEndDate(resp.eventDetailsEventEndDate);
        setDisplayStartDate(resp.eventDetailsDisplayStartDate);
        setDisplayEndDate(resp.eventDetailsDisplayEndDate);
        setDivision(resp.divNbr + "-" + resp.divName);
        setEventLocation(flag === 'C' & flag1 === null  ? "" : resp.locNbr);
        setEventId(resp.eventId);
        setEventName(resp.eventName);
        setActivateEvent(toUpperCaseString(resp.eventDetailsActive) == 'Y' ? true : false);
        setAllowUnavailable(toUpperCaseString(resp.eventDetailsUnavailableActive) == 'Y' ? true : false);
        setEventLocationId(resp.locId);
    }

    const updateEventHours = (start, end) => {
        console.log("start in main page", start);
        console.log("end in main page", end);
        setStartHours(start);
        setEndHours(end);
    }

    const updateAllowPartial = (val) => {
        console.log("allow partial", val);
        setAllowPartialShiftSelection(val === true ? 'Y' : 'N');
    }

    const handleAlertNotifClose = () => {
        setAlertOpen({});
    };

    const getEventDetailsApi = async (locId = null, locNbr = null, flag1 = null) => {
        if(location.state.flag2 === "FE") {
            alert("made it here after add cancel")
        }
        let data = {
            divId: eventBaseData.divId,
            divNbr: eventBaseData.divNbr,
            divName: eventBaseData.divName,
            locId: locId === null ? eventBaseData.locId : locId,
            locNbr: locNbr === null ? eventBaseData.locNbr : locNbr,
            eventId: eventBaseData.eventId,
            eventName: eventBaseData.eventName
        }
        axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_EVENT_CONTROL_GET_ADMIN_EVENT_CONTROLS_FOR_LOCATION}`,
            data,
            {
                headers: {
                    'content-type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            })
            .then((response) => {
                console.log("response is", response.data)
                setEventDetailApiData(response.data)
                // shift state
                setShiftsDropDownIntervals(response.data.shiftsDropDownIntervals);
                setshiftsMinimumSelectionHours(response.data.shiftsMinimumSelectionHours);
                setAllowSplitShift(toUpperCaseString(response.data.shiftsAllowSplitShifts) == 'Y' ? true : false);
                setForceMinSelectionHours(toUpperCaseString(response.data.shiftsForceMinimumSelectionHours) == 'Y' ? true : false);


                // scheduled areas state
                setscheduleArea(response.data.scheduleAreasDptValues)
                setscheduleAreaRadio(response.data.scheduleAreasDptExcluded === true ? "item-2" : "item-1")
                setWorkScheduleRadio(response.data.workScheduleWsExcluded === true ? "item-2" : "item-1")
                // work schedule state
                setWorkSchedule(response.data.workScheduleWsValues)

                // pass data to event details
                setUpEventDetailsStatesValues(response.data, flag1)

            })
            .catch((error) => {
                // error
                // Todo: remove once api is up
                // store.dispatch(workScheduleActions.setWorkScheduleState([ ...data ])); 

                if (error.message === 'Network Error') {
                    history("/somethingwentwrong", { state: `Please logout and try again ` })
                } else {
                    history("/somethingwentwrong", { state: `${constants.WFM_EVENT_CONTROL_GET_ADMIN_EVENT_CONTROLS_FOR_LOCATION}...failed` })
                }

            })
    }

    const deleteEventLocation = () => {
        // call delete api

        let data = {
            locId: eventBaseData.locId,
            locNbr: eventBaseData.locNbr,
            eventId: eventBaseData.eventId,
        }

        axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_DELETE_ADMIN_EVENT_LOCATION_CONTROLS_BY_EVENT_AND_LOCID}`,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token,
                }
            }).then((res) => {
                dialog.hide();
                history("/controls/specialeventscontrols/searchevent", {state:`DeleteLocation`})
            }).catch((err) => {
                
        });   

        
    }

    const saveData = () => {
        //alert("data saving")
        let len = Object.keys(startHours).length;
        let eventHours = [];
        for (let i = 1; i <= len; i++) {
            let tmp = {};
            tmp.seqNbr = i;
            tmp.ctlName = "ddeventdayhrs";
            tmp.value1 = startHours[i];
            tmp.value2 = endHours[`end-${i}`]
            eventHours.push(tmp)
        }
        console.log(eventHours);
        // check if any eventHours is null and throw error
        const isEventHoursNull = Object.values(eventHours).some(x => (x.value1 === null || x.value2 === null));
        // check if locnbr has string
        let locNbrvalid = isNaN(eventLocation) === true ? false : true;
        if (isEventHoursNull) {
            setAlertOpen({
                open: true,
                severity: "error",
                message: "Event Hours cannot be null.",
            })

        } else if(!locNbrvalid) {
            setAlertOpen({
                open: true,
                severity: "error",
                message: "Please enter a valid location.",
            })

        } else if(moment(eventEndDate).isBefore(moment(eventStartDate))) {
            setAlertOpen({
                open: true,
                severity: "error",
                message: "Event End date should be greater than Event Start date",
            })

        } else if(moment(displayEndDate).isBefore(moment(displayStartDate))) {
            setAlertOpen({
                open: true,
                severity: "error",
                message: "Display End date should be greater than Display Start date",
            })

        }  else if(moment(displayStartDate).isAfter(moment(eventStartDate)) || moment(displayStartDate).isSame(moment(eventStartDate)) ) {
            setAlertOpen({
                open: true,
                severity: "error",
                message: "Display Start date should be before Event Start date",
            })

        } else if(moment(displayEndDate).isAfter(moment(eventStartDate)) || moment(displayEndDate).isSame(moment(eventStartDate)) ) {
            setAlertOpen({
                open: true,
                severity: "error",
                message: "Display End date should be before Event Start date",
            })

        } else if (isString(shiftsDropDownIntervals)) {

            setAlertOpen({
              open: true,
              severity: "error",
              message: "Drop down intervals should be numeric.",
            });
            return;
          } else if (isString(shiftsMinimumSelectionHours)) {

            setAlertOpen({
              open: true,
              severity: "error",
              message: "Minimum selection hours should be numeric.",
            });
            return;
          } else {

            let momentEventStartDate = moment(eventStartDate).format('MM/DD/YYYY');
            let momentEventEndDate = moment(eventEndDate).format('MM/DD/YYYY');
            let momentDisplayStartDate = moment(displayStartDate).format('MM/DD/YYYY');
            let momentDisplayEndDate = moment(displayEndDate).format('MM/DD/YYYY');

            let data = {
                divId: eventBaseData.divId,
                divNbr: eventBaseData.divNbr,
                divName: eventBaseData.divName,
                locId: flag === "E" ? eventLocationId : null,
                locNbr: eventLocation,
                eventId: eventBaseData.eventId,
                eventName: eventBaseData.eventName,
                eventDetailsEventStartDate: momentEventStartDate !== "Invalid date" ? momentEventStartDate : "",
                eventDetailsEventEndDate: momentEventEndDate !== "Invalid date" ? momentEventEndDate : "",
                eventDetailsDisplayStartDate: momentDisplayStartDate !== "Invalid date" ? momentDisplayStartDate : "",
                eventDetailsDisplayEndDate: momentDisplayEndDate !== "Invalid date" ? momentDisplayEndDate : "",
                eventDetailsActive: activateEvent === true ? 'y' : 'n',
                eventDetailsUnavailableActive: allowUnavailable === true ? 'y' : 'n',
                shiftsDropDownIntervals: shiftsDropDownIntervals,
                shiftsAllowSplitShifts: allowSplitShift === true ? 'y' : 'n',
                shiftsMinimumSelectionHours: shiftsMinimumSelectionHours,
                shiftsForceMinimumSelectionHours: forceMinSelectionHours === true ? 'y' : 'n',
                eventHours: eventHours,
                eventHoursAllowPartialShiftSelection: allowPartialShiftSelection,
                scheduleAreasDptValues: scheduleArea,
                scheduleAreasDptExcluded: scheduleAreaRadio === "item-1" ? false : true,
                workScheduleWsValues: workSchedule,
                workScheduleWsExcluded: workScheduleRadio === "item-1" ? false : true,
                action: flag,
                lastUpdatedBy: personStaticDetails.emplID
            }



            axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_EVENT_CONTROL_SAVE_ADMIN_EVENT_CONTROLS_FOR_LOCATION}`,
                data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token,
                    }
                }).then((res) => {
                    // call api to fetch data
                    if (flag === "E" || flag === "C") {
                        let msg = "Event saved successfully";
                        if(flag === "E") {
                         getEventDetailsApi(res.data.locId,eventLocation,"Edit");
                        } else {
                        setFlag("E");
                        msg = "Event location saved successfully"
                        getEventDetailsApi(res.data.locId,eventLocation,"Edit");
                        }
                        makeReadOnly();
                        setAlertOpen({
                            open: true,
                            severity: "success",
                            message: msg,
                        })
                    }

                    if(flag === "A") {
                        setFlag("E");
                        makeReadOnly();
                        getEventDetailsApi(res.data.locId,eventLocation,"Edit");
                        setAlertOpen({
                            open: true,
                            severity: "success",
                            message: "Event location added successfully",
                        })
                    }

                    


                }).catch((err) => {
                    //alert("error")
                    setAlertOpen({
                        open: true,
                        severity: "error",
                        message: err.response.data.message,
                    })
                });
        } // evenhours not null
    }

    let locid = eventBaseData.locId
    return (
        <div className={classes.eventpagemargin}>
            <Box>
                <Dialog
                    open={dialog.open}
                    title={eventBaseData.locNbr === 0 ? 'Delete Location 0' : 'Confirm Delete Event Location'}
                    onClose={dialog.hide}
                    
                    actions={
                        
                        <>
                            {eventBaseData.locNbr !== 0 &&
                            <>
                            <Button color="secondary" onClick={dialog.hide}>No</Button>
                            <Button onClick={deleteEventLocation}>Yes</Button>
                            </>
                            }
                            {eventBaseData.locNbr === 0 &&
                            <>
                            <Button  onClick={dialog.hide}>Ok</Button>
                            
                            </>
                            }
                        </>
                        
                        
                    }
                    
                >
                    {eventBaseData.locNbr !== 0 && 
                    <Typography>Are you sure you want to delete this event location?</Typography>
                    }
                    {eventBaseData.locNbr === 0 && 
                    <Typography style={{color:"red"}}><img src={warning_delete}/> You cannot delete Location 0. You need to delete the entire event.</Typography>
                    }
                </Dialog>
            </Box>

            <div style={{ width: "100%" }}>
                <div className={eventClasses.eventpagetitle} style={{ textAlign: "left", width: "40%" }} >{location.state.data.eventName}</div>
                <div className={eventClasses.eventpagetitle2} style={{ textAlign: "right", width: "50%" }}>
                    <div className="eventicon2" ><img className="images" src={ongoingActionCompleted ? add : add_disable} />
                        <span style={{ pointerEvents:(ongoingActionCompleted) ? "auto":"none" , color: ongoingActionCompleted ? "inherit" : "grey", marginLeft: "5px",cursor:"pointer",textDecoration:"underline" }} onClick={
                            ongoingActionCompleted ? addEvent : undefined
                        } >
                            Add
                        </span>
                    </div>
                    <div className="eventicon2" ><img className="images" width={20} height={20} src={ongoingActionCompleted ? duplicate : duplicate_disable} />
                        <div style={{ pointerEvents:(ongoingActionCompleted) ? "auto":"none" , color: ongoingActionCompleted ? "inherit" : "grey", display: "inline-block", marginLeft: "5px",cursor:"pointer",textDecoration:"underline" }} onClick={
                            ongoingActionCompleted ? duplicateEvent : undefined
                        } >Duplicate </div>
                    </div>
                    <div className="eventicon2"> <img className="images" src={ongoingActionCompleted ? deleteimg : delete_disable} />
                        <span style={{ pointerEvents:(ongoingActionCompleted) ? "auto":"none" , color: ongoingActionCompleted ? "inherit" : "grey", marginLeft: "5px",cursor:"pointer",textDecoration:"underline" }} onClick={
                            ongoingActionCompleted ? dialog.show : undefined
                        } >Delete</span>
                    </div>
                </div>
            </div>
            {readOnlyView &&
                <NotificationView
                    message={"'Read-only' view, click on 'Edit' to edit event details."} severity="info" />
            }
            <div className={eventClasses.eventiconmargin}>



                <div className={classes.pagesubtitle}> </div>
                { /*  Event details code goes here */}

                <div>


                    <div className={eventClasses.eventpagemargin}>


                        <Grid container spacing={4} >

                            <Grid item xs={2}>
                                <div className={eventClasses.eventDetails}> Event Details </div>
                            </Grid>

                            <Grid item xs={2} >
                                <TextField inputProps={{ readOnly: true }} sx={{ minWidth: "100%" }} label="Division" value={division} />
                            </Grid>
                            <Grid item xs={2}>
                                <TextField inputProps={{ readOnly: true }} sx={{ minWidth: "100%" }} label="Event Name" value={eventName} />
                            </Grid>
                            <Grid item xs={2}>
                                <TextField inputProps={{ readOnly: true }} sx={{ minWidth: "100%" }} label="Event ID" value={eventId} />
                            </Grid>
                            <Grid item xs={2}>
                             <TextField inputProps={{ readOnly: flag === 'E' ? true : false }} sx={{ minWidth: "100%" }} label="Location" value={eventLocation} onChange={changeLocation} />
                            </Grid>
                            <Grid item xs={2} >
                            </Grid>
                            <Grid item xs={2}>
                            </Grid>
                            <Grid item xs={2} >
                                <FormControl style={{ minWidth: '100%' }}>
                                    <DatePicker
                                        label="Event Start Date"
                                        renderInput={(params) => (
                                            <TextField {...params} />
                                        )}
                                        inputFormat="MM/dd/yyyy"
                                        value={eventStartDate || null}
                                        onChange={(newValue) => {
                                            setEventStartDate(newValue);
                                        }}
                                        // components={{
                                        //     OpenPickerIcon: CalIcon
                                        // }}
                                        readOnly={readOnlyView}
                                        showDaysOutsideCurrentMonth
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={2} >
                                <FormControl style={{ minWidth: '100%' }}>
                                    <DatePicker
                                        label="Event End Date"
                                        renderInput={(params) => (
                                            <TextField {...params} />
                                        )}
                                        inputFormat="MM/dd/yyyy"
                                        value={eventEndDate || null}
                                        onChange={(newValue) => {
                                            setEventEndDate(newValue);
                                        }}
                                        // components={{
                                        //     OpenPickerIcon: CalIcon
                                        // }}
                                        readOnly={readOnlyView}
                                        showDaysOutsideCurrentMonth
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={2}>
                                <FormControl style={{ minWidth: '100%' }}>
                                    <DatePicker
                                        label="Display Start Date"
                                        renderInput={(params) => (
                                            <TextField {...params} />
                                        )}
                                        inputFormat="MM/dd/yyyy"
                                        value={displayStartDate || null}
                                        onChange={(newValue) => {
                                            setDisplayStartDate(newValue);
                                        }}
                                        // components={{
                                        //     OpenPickerIcon: CalIcon
                                        // }}
                                        readOnly={readOnlyView}
                                        showDaysOutsideCurrentMonth
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={2} >
                                <FormControl style={{ minWidth: '100%' }}>
                                    <DatePicker
                                        label="Display End Date"
                                        renderInput={(params) => (
                                            <TextField {...params} />
                                        )}
                                        inputFormat="MM/dd/yyyy"
                                        value={displayEndDate || null}
                                        onChange={(newValue) => {
                                            setDisplayEndDate(newValue);
                                        }}
                                        // components={{
                                        //     OpenPickerIcon: CalIcon
                                        // }}
                                        readOnly={readOnlyView}
                                        showDaysOutsideCurrentMonth
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={2} >
                            </Grid>
                            <Grid item xs={2} >
                            </Grid>
                            <Grid item xs={2} >
                                <FormControl>
                                    <FormControlLabel inputProps={{ readOnly: readOnlyView }} onChange={changeActivateEvent} control={<Checkbox checked={activateEvent} disabled={readOnlyView} />} label='Activate this Event' />
                                </FormControl>
                            </Grid>
                            <Grid item xs={4} >
                                <FormControl>
                                    <FormControlLabel inputProps={{ readOnly: readOnlyView }} onChange={changeAllowUnavailable} control={<Checkbox checked={allowUnavailable} disabled={readOnlyView} />} label='Allow Colleague To Be Unavailable For This Event' />
                                </FormControl>
                            </Grid>


                        </Grid>
                    </div>

                </div>



                { /*  Event shift code goes here */}

                <div>

                    <div className={eventClasses.eventpagemargin}>


                        <Grid container spacing={4} columns={6}>

                            <Grid item xs={1}>
                                <div className={eventClasses.shift}>Shifts</div>
                            </Grid>

                            <Grid item xs={1}>
                                <TextField inputProps={{ readOnly: readOnlyView }} sx={{ minWidth: "100%" }} label="Drop Down Intervals" value={shiftsDropDownIntervals} onChange={changeDropDownIntervals} />
                            </Grid>
                            <Grid item xs={1} >
                                <TextField inputProps={{ readOnly: readOnlyView }} sx={{ minWidth: "100%" }} label="Enter Minimum Selection Hrs" value={shiftsMinimumSelectionHours} onChange={changeShiftsMinimumSelectionHours} />
                            </Grid>
                            <Grid item xs={1} >
                            </Grid>
                            <Grid item xs={1} >
                            </Grid>
                            <Grid item xs={1} >
                            </Grid>
                            <Grid item xs={1} >
                            </Grid>
                            <Grid item xs={1} >
                                <FormControl>
                                    <FormControlLabel inputProps={{ readOnly: readOnlyView }} onChange={changeAllowSplitShift} control={<Checkbox checked={allowSplitShift} disabled={readOnlyView} />} label='Allow Split Shifts' />
                                </FormControl>
                            </Grid>
                            <Grid item xs={2} >
                                <FormControl>
                                    <FormControlLabel inputProps={{ readOnly: readOnlyView }} onChange={changeForceMinSelectionHours} control={<Checkbox checked={forceMinSelectionHours} disabled={readOnlyView} />} label='Force Minimum Selection Hours' />
                                </FormControl>
                            </Grid>

                        </Grid>
                    </div>

                </div>


                {((eventDetailApiData !== null || flag === "A") && (flag === "E" || flag === "A" || flag === "C")) &&
                    <EventHours flag={flag} cancelFlag={cancelFlag} readOnlyView={readOnlyView} updateEventHours={updateEventHours} updateAllowPartial={updateAllowPartial} eventHours={eventDetailApiData !== null ? eventDetailApiData.eventHours : []} eventHoursAllowPartialShiftSelection={eventDetailApiData !== null ? eventDetailApiData.eventHoursAllowPartialShiftSelection : null} />}



                { /*  schedule areas code goes here */}

                <div>
                    <div className={eventClasses.eventpagemargin}>
                        <Grid container spacing={3} >
                            <Grid item xs={2}>
                                <div className={eventClasses.scheduledAreas}> Scheduled Areas </div>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField inputProps={{ readOnly: readOnlyView }} multiline={true} onChange={changeScheduleArea} sx={{ minWidth: "100%" }} label="Department (Opt)" value={scheduleArea} defaultValue={scheduleArea} />
                            </Grid>
                        </Grid>
                        <Grid container spacing={3} >
                            <Grid item xs={2}>
                            </Grid>
                            <Grid item xs={4} >
                                <FormControl component="fieldset">
                                    <RadioGroup row onChange={changeScheduleAreaRadio} defaultValue={scheduleAreaRadio} name="radio-buttons-group">
                                        <FormControlLabel
                                            disabled={readOnlyView}
                                            value="item-1"
                                            control={<Radio checked={scheduleAreaRadio === "item-1"} />}
                                            label="Include Department"
                                            sx={{ '.MuiFormControlLabel-label': { fontSize: 13 } }}
                                        />
                                        <FormControlLabel
                                            disabled={readOnlyView}
                                            value="item-2"
                                            control={<Radio checked={scheduleAreaRadio === "item-2"} />}
                                            label="Exclude Department"
                                            sx={{ '.MuiFormControlLabel-label': { fontSize: 13 } }}
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>

                        </Grid>


                    </div>
                </div>


                { /* work schedule code goes here */}

                <div>
                    <div className={eventClasses.eventpagemargin}>
                        <Grid container spacing={3} >
                            <Grid item xs={2}>
                                <div className={eventClasses.scheduledAreas}> Work Schedule </div>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField inputProps={{ readOnly: readOnlyView }} multiline={true} onChange={changeWorkSchedule} sx={{ minWidth: "100%" }} label="Work Schedule (Opt)" value={workSchedule} defaultValue={workSchedule} />
                            </Grid>
                        </Grid>
                        <Grid container spacing={3} >
                            <Grid item xs={2}>
                            </Grid>
                            <Grid item xs={4} >
                                <FormControl component="fieldset">
                                    <RadioGroup onChange={changeWorkScheduleRadio} row defaultValue={workScheduleRadio} name="radio-buttons-group">
                                        <FormControlLabel
                                            disabled={readOnlyView}
                                            value="item-1"
                                            control={<Radio checked={workScheduleRadio === "item-1"} />}
                                            label="Include Work Schedule"
                                            sx={{ '.MuiFormControlLabel-label': { fontSize: 13 } }}
                                        />
                                        <FormControlLabel
                                            disabled={readOnlyView}
                                            value="item-2"
                                            control={<Radio checked={workScheduleRadio === "item-2"} />}
                                            label="Exclude Work Schedule"
                                            sx={{ '.MuiFormControlLabel-label': { fontSize: 13 } }}
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>

                        </Grid>


                    </div>

                    <SnackBar
                        open={open}
                        message={message}
                        severity={severity}
                        onClose={handleAlertNotifClose}
                    ></SnackBar>
                    {<Edit readOnlyView={readOnlyView} />}
                </div>
            </div>
        </div>

    );
}

export default EventDetailsPage;